import { initializeApp } from 'firebase/app';
import * as FirebaseAnalytics from '@firebase/analytics';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGE_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_SEASUREMENT_ID,
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = FirebaseAnalytics.initializeAnalytics(app, { config: { send_page_view: false } });

export default analytics;

export const setUserId = (userId: string | null) => {
    FirebaseAnalytics.setUserId(analytics, userId);
};
export const logEvent = (eventName: string, eventParams?: Record<string, unknown>) => {
    FirebaseAnalytics.logEvent(analytics, eventName, eventParams);
};
